import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { getDataGridLocalization } from '@/features/researchers/constants';
import { dataGridContainerStyles } from '@/features/researchers/styles';
import { useUserListColumns } from '@/features/researchers/components';
import { type Researcher } from '@aphp-ema/common/researchers';
import type { DataGridProps } from '@mui/x-data-grid';

interface DataGridWrapperProps {
  rows: readonly Researcher[];
  dataGridProps: Partial<DataGridProps>;
}

/**
 * Component that wraps the DataGrid with proper configuration
 */
export const DataGridWrapper: React.FC<DataGridWrapperProps> = ({
  rows,
  dataGridProps,
}) => {
  const { t } = useTranslation();
  const columns = useUserListColumns();
  const localeText = getDataGridLocalization(t);

  return (
    <DataGrid
      {...dataGridProps}
      rows={rows}
      columns={columns}
      autoHeight
      localeText={localeText}
      sx={dataGridContainerStyles}
    />
  );
};
